// extracted by mini-css-extract-plugin
module.exports = {"app":"app--app-styles__1aFqX","public-profiles-wrapper":"public-profiles-wrapper--app-styles__OuFUO","publicProfilesWrapper":"public-profiles-wrapper--app-styles__OuFUO"};